import { render, staticRenderFns } from "./copyright.vue?vue&type=template&id=0e4c2a0e&scoped=true"
import script from "./copyright.vue?vue&type=script&lang=js"
export * from "./copyright.vue?vue&type=script&lang=js"
import style0 from "./copyright.vue?vue&type=style&index=0&id=0e4c2a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4c2a0e",
  null
  
)

export default component.exports